import "./shelvesExpandables.css";
import { BinExpandable } from "../BinExpandable/BinExpandable";
import HierarchyLines from "../../../../TestLine/HierarchyLines";
import React, { useState, useEffect, useContext } from "react";
import "./shelvesExpandables.css";
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import {
  localStorageGet,
  localStorageRemove,
  localStorageSave,
} from "../../../../services/localStorageService";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES, LABELS } from "../../../../globals/globals";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { getUserCompanyId } from "../../../../services/authService";
import { createBin, DeleteShelf, getBins, getShelf, UpdateShelf } from "../../services/locationsConfigurationService";
import { DialogContext } from "../../../../contexts/DialogContext";
import { ShelfDeleteModal } from "./ShelfDeleteModal/ShelfDeleteModal";
import { environment } from "../../../../environments/environment";
import Input from '../../../../components/Inputs/Input';
import { LocationsContext } from "../../contexts/LocationsContext";
import { validateDate } from "@mui/x-date-pickers";

const typeMeasurementMap = {
  Meters: "m",
  Centimeters: "cm",
  Millimeters: "mm",
  Inches: "in",
  Feet: "ft",
}
const shelfDraftPrefix = "configuration/locationConfiguration/draft/shelves/";
const binDraftPrefix = "configuration/locationConfiguration/draft/bins/";
export const ShelvesExpandable = ({
  idx,
  Length,
  isDraft = false,
  isNewShelf = false,
  reload = "",
  inforDraft,
  parentLenghts,
  shelfBasicInfo,
  locationId,
  siteId,
  rack_id,
  fullTotalLenght
}) => {

  // const [descriptionValue, setDescriptionValue] = useState("");
  // Cambiar los estados iniciales para usar shelfBasicInfo directamente
  const [informationOfDraft, setInformationOfDraft] = useState(inforDraft)
  const [nameValue, setNameValue] = useState(shelfBasicInfo?.name || "");
  const [lengthValue, setLengthValue] = useState(shelfBasicInfo?.length || "");
  const [widthValue, setWidthValue] = useState(shelfBasicInfo?.width || "");
  const [depthValue, setDepthValue] = useState(shelfBasicInfo?.depth || "");
  const [UOMName, setUOMName] = useState(shelfBasicInfo?.uomName || null);
  const [preselectUOMDrop, setPreselectUOMDrop] = useState(null);
  const [UOMSelected, setUOMSelected] = useState(null);

  const [draft, setDraft] = useState(isDraft);
  const [childrenDraft, setChildrenDraft] = useState(false)
  const [newShelf, setNewShelf] = useState(isNewShelf);

  const [shelfCompleteData, setShelfCompleteData] = useState(null);
  const [shelfDataInDraft, setShelfDataInDraft] = useState(null);
  const { warningMsg, successMsg } = useSnackBar();
  const [hasNameError, setHasNameError] = useState(false);

  const [UOMDropdownConfig, setUOMDropdownConfig] = useState(null);
  const openLocationId = useSelector((state) => state.locationSites.openLocationId);
  const [filtersToMeasurements, setFiltersToMeasurements] = useState(null)
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(environment.ElemensPerPage);
  const [totalBins, setTotalBins] = useState(null)
  const [viewMode, setViewMode] = useState('closed');
  const [isExpanded, setIsExpanded] = useState(false);
  const [version, setVersion] = useState(0)
  const { draftStatusChanged, setDraftStatusChanged } = useContext(LocationsContext);

  const validateFields = () => {
    let isValid = true;

    if (!nameValue.trim()) {
      setHasNameError(true);
      isValid = false;
    } else {
      setHasNameError(false);
    }

    // if (lengthValue == null || lengthValue == undefined || lengthValue == "" || lengthValue < 0) {
    //   setHasLengthError(true);
    //   isValid = false;
    // } else {
    //   setHasLengthError(false);
    // }

    // if (widthValue == null || widthValue == undefined || widthValue == "" || widthValue < 0) {
    //   setHasWidthError(true);
    //   isValid = false;
    // } else {
    //   setHasWidthError(false);
    // }

    // if (depthValue == null || depthValue == undefined || depthValue == "" || depthValue < 0) {
    //   setHasDepthError(true);
    //   isValid = false;
    // } else {
    //   setHasDepthError(false);
    // }

    // if (UOMSelected == null || UOMSelected == undefined || UOMSelected == "" || Object.keys(UOMSelected).length === 0) {

    //   setHasOUMError(true);
    //   isValid = false;
    // } else {
    //   setHasOUMError(false);
    // }

    if (!isValid) {
      warningMsg("Fields required", "Certain empty fields or negative numbers are not allowed");
    }

    return isValid;
  };

  const saveInDraft = () => {
    if (shelfDataInDraft !== null && viewMode == "edit") {
      localStorageSave(
        shelfDraftPrefix,
        { locationId: locationId, siteId: siteId, rackId: rack_id, shelfId: shelfBasicInfo.id },
        shelfDataInDraft
      );
      setDraftStatusChanged(!draftStatusChanged)

    }
  };
  const saveShelf = async (typeOfFinish = "") => {
    if (!validateFields()) {
      return;
    }


    if (typeOfFinish === "end") {
      let { UOMName, ...shelfDataWithoutUOMName } = shelfDataInDraft;
      let request = await UpdateShelf(shelfDataWithoutUOMName);
      // let request = await UpdateShelf(shelfDataInDraft);


      if (request.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
        successMsg("Shelf updated", "The shelf has been updated successfully.");
        setInformationOfDraft(null)
        setShelfCompleteData(request.data.load)
        // setNameValue(request.data.load.name ? request.data.load.name : "");
        // setLengthValue(request.data.load?.length ? request.data.load?.length: "");
        // setWidthValue(request.data.load?.width ? request.data.load?.width : "");
        // setDepthValue(request.data.load?.depth ? request.data.load?.depth : "");
        // setPreselectUOMDrop(request.data.load?.unitsOfMeasureId ? request.data.load?.unitsOfMeasureId : "");
        // setUOMSelected(request.data.load?.unitsOfMeasureId ?
        //   { "UOM.id":request.data.load?.unitsOfMeasureId } : null);
        // setVersion(request.data.load.version ? request.data.load.version : 0);

        localStorageRemove(shelfDraftPrefix, { shelfId: shelfBasicInfo.id });
        setDraftStatusChanged(!draftStatusChanged)

        setDraft(false);
        setNewShelf(false)
        setIsExpanded(false);
        setViewMode("closed");
        // setTimeout(() => {
        //   if (reload) {
        //     reload();
        //   }
        // }, 100);
      }


    } else {
      let { UOMName, ...shelfDataWithoutUOMName } = shelfDataInDraft;
      let request = await UpdateShelf(shelfDataWithoutUOMName);

      if (request.data.responseCode == HTTP_RESPONSE_CODES.UPDATED) {
        let unitsOfMeasureIdTarget = "UOM.id"
        setVersion(request.data.load.version)
        const data = {
          version: request.data.load.version,
          id: request.data.load.version,
          name: nameValue,
          // description: descriptionValue,
          length: lengthValue,
          width: widthValue,
          depth: depthValue,
          unitsOfMeasureId: UOMSelected[unitsOfMeasureIdTarget],
          rackId: rack_id,
          companyId: getUserCompanyId(),
          status: "active"
        }
        setShelfDataInDraft(data)
        successMsg("Shelf updated", "The shelf has been updated successfully.");
        setDraft(true);
      }

    }
  };
  const getShefInfo = async () => {
    let request = await getShelf(shelfBasicInfo.id)
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setShelfCompleteData(request.data.load)
    }
  }

  const cancelShelfEdition = () => {
    localStorageRemove(shelfDraftPrefix, {
      shelfId: shelfCompleteData?.id.toString(),
    });
    setDraftStatusChanged(!draftStatusChanged)

    setIsExpanded(false);
    setViewMode("closed");
    setDraft(false);
    setNewShelf(false)
    if (reload) {
      reload();
    }
  };

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    {
      label: "Save and Continue Editing",
      icon: "icon-save",
      id: "save-continue",
    },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => saveShelf("end"),
    "save-continue": () => saveShelf("continue"),
    cancel: () => cancelShelfEdition(),
  };

  const getUOMDropdownConfig = async () => {
    let dropdownId = 40;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setUOMDropdownConfig(request.data.load);
    }
  };

  const deleteThisShelf = async () => {
    let request = await DeleteShelf(shelfBasicInfo.id)
    if (request.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
      successMsg("Shelf deleted", "The shelf has been deleted successfully.");
      localStorageRemove(shelfDraftPrefix, { shelfId: shelfBasicInfo.id });
      setDraftStatusChanged(!draftStatusChanged)

      closeDialog()
      if (reload) {
        reload();
      }
    }
  }

  const openDeleteShelfDialog = () => {
    openDialog({
      component: ShelfDeleteModal,
      props: {
        shelfName: nameValue,
        // shelfDescription: descriptionValue,
        onClose: closeDialog,
        deleteShelf: deleteThisShelf
      }
    })
  }

  const [bins, setBins] = useState([]);
  const [binsDraft, setBinsDraft] = useState([]);
  const [allbins, setAllBins] = useState([])
  const [mostRecentBin, setMostRecentBin] = useState(null)

  const getAllBins = async () => {
    let binsInDraft = localStorageGet(binDraftPrefix, { shelfId: shelfBasicInfo.id });
    let body = [
      {
        columnName: "shelfId",
        value: shelfBasicInfo.id,
      },
      {
        columnName: "accountId",
        value: [parseInt(localStorage.getItem("u_account_id"))],
      },
    ]
    let request = await getBins(page, pageSize, "id", body)

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setBins(request.data.load)
      setBinsDraft(binsInDraft)
      setTotalBins(request.data.totalRecords)
      if (request.data.load.length <= 0 && binsInDraft.length <= 0) {
        setIsExpanded(false);
        setViewMode("closed")
      }
    }
  }



  const createNewBin = async () => {
    let request = await createBin();

    if (request.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
      successMsg("Bin created", "The bin has been created successfully.");
      localStorageSave(binDraftPrefix, { locationId: locationId, siteId: siteId, rackId: rack_id, shelfId: shelfBasicInfo.id, binId: request.data.load.id }, request.data.load);
      setDraftStatusChanged(!draftStatusChanged)

      setMostRecentBin(request.data.load.id)
      setIsExpanded(true)
      setViewMode("bins")
      setBins(() => {
        return [...bins, request.data.load];
      })
      getAllBins()

    }

  }

  const combineBins = () => {
    const uniqueBins =
      binsDraft.length > 0
        ? binsDraft.filter(
          (bin) => !bins.some((bs) => bs.id == bin.id)
        )
        : [];

    setAllBins([...uniqueBins, ...bins]);
  }

  useEffect(() => combineBins(), [bins, binsDraft])

  useEffect(() => {
    if (informationOfDraft) {

      setNameValue(informationOfDraft.name || "");
      setLengthValue(informationOfDraft?.length ? informationOfDraft?.length : "");
      setWidthValue(informationOfDraft?.width ? informationOfDraft?.width : "");
      setDepthValue(informationOfDraft?.depth ? informationOfDraft?.depth : "");
      setPreselectUOMDrop(informationOfDraft?.unitsOfMeasureId ? informationOfDraft.unitsOfMeasureId : "");
      setUOMSelected(informationOfDraft?.unitsOfMeasureId ? {
        "UOM.id": informationOfDraft.unitsOfMeasureId,
      } : "");
      setUOMName(informationOfDraft?.UOMName ? informationOfDraft.UOMName : null);
      setVersion(informationOfDraft?.version ? informationOfDraft.version : 0);
    } else if (shelfCompleteData) {
      setNameValue(shelfCompleteData?.name ? shelfCompleteData?.name : "");
      setLengthValue(shelfCompleteData?.length ? shelfCompleteData?.length : "");
      setWidthValue(shelfCompleteData?.width ? shelfCompleteData?.width : "");
      setDepthValue(shelfCompleteData?.depth ? shelfCompleteData?.depth : "");
      setPreselectUOMDrop(shelfCompleteData?.unitsOfMeasureId ? shelfCompleteData.unitsOfMeasureId : "");
      setUOMSelected(shelfCompleteData?.unitsOfMeasureId ?
        { "UOM.id": shelfCompleteData?.unitsOfMeasureId } : null);
      setVersion(shelfCompleteData.version ? shelfCompleteData.version : 0);
    }
  }, [informationOfDraft, shelfCompleteData]);

  useEffect(() => {
    validateChildDraftStatus()
  }, [draftStatusChanged])


  const validateChildDraftStatus = () => {

    let hasBinsDraft = localStorageGet(binDraftPrefix, { shelfId: shelfBasicInfo.id});

    const hasAnyChildrenDraft = (
      (hasBinsDraft?.length || 0) > 0
    );

    setChildrenDraft(hasAnyChildrenDraft);
  };

  useEffect(() => {
    validateChildDraftStatus()
    if (newShelf == true) {
      setViewMode("edit");
      setIsExpanded(true);
    }
    setMostRecentBin(null)
    setTotalBins(shelfBasicInfo.bins)
  }, []);

  useEffect(() => {
    setFiltersToMeasurements(() => {
      return [
        { columnName: "l.id", value: openLocationId },
        { columnName: "measure_type", value: "length" },
        { columnName: "context", value: "shelf" }
      ]
    })
  }, [openLocationId])

  useEffect(() => {
    if (!UOMDropdownConfig && isExpanded) {
      getUOMDropdownConfig();
    }
    if (isExpanded) {
      getShefInfo()
    }

    if (isExpanded && viewMode == "bins") {
      getAllBins()
    }
  }, [isExpanded, viewMode]);


  useEffect(() => {
    if (isExpanded && viewMode == "edit" && shelfCompleteData) {
      let uomId = UOMSelected?.["UOM.id"] ? UOMSelected?.["UOM.id"] : null;
      const data = {
        version: version,
        id: parseInt(shelfBasicInfo.id),
        name: nameValue,
        // description: descriptionValue,
        length: parseInt(lengthValue),
        width: parseInt(widthValue),
        depth: parseInt(depthValue),
        unitsOfMeasureId: parseInt(uomId),
        rackId: parseInt(rack_id),
        accountId: parseInt(localStorage.getItem("u_account_id")),
        status: "active",
        UOMName: UOMName
      }

      setShelfDataInDraft(data)
    }

  }, [nameValue, UOMSelected, lengthValue, depthValue, widthValue, version, UOMName])

  useEffect(() => {
    saveInDraft()
  }, [shelfDataInDraft, shelfCompleteData])


  const getUOMSelection = (value) => {
    setUOMSelected(value);
    if (value && value["UOM.id"]) {
      setPreselectUOMDrop(value["UOM.id"]);
      setUOMName(value["UOM.name"])
    } else {
      setPreselectUOMDrop(null);
    }
  };


  const handleHeaderClick = () => {
    if (viewMode === 'edit') return;

    if (viewMode !== 'closed') {
      setViewMode('closed');
      setIsExpanded(false);
    } else {
      setViewMode('form');
      setIsExpanded(true);
    }
  };

  const handleViewShelves = (e) => {
    e.stopPropagation();

    if (viewMode === 'bins') {

      setViewMode('closed');
      setIsExpanded(false);
    } else {

      setViewMode('bins');
      setIsExpanded(true);
    }
  };


  const handleEditClick = (e) => {
    e.stopPropagation();
    setViewMode('edit');
    setIsExpanded(true);
    setDraft(true)
  };

  function getMeasurementText(length, width, depth, UOM, typeMeasurementMap, binBasicInfo) {

    const measures = [length, width, depth].filter(measure =>
      measure !== null && measure !== undefined && measure !== ''
    );
    const uom = typeMeasurementMap[UOM?.['UOM.name']] ? typeMeasurementMap[UOM?.['UOM.name']] : typeMeasurementMap[UOMName] ? typeMeasurementMap[UOMName] : shelfBasicInfo?.uomAbreviation || '';

    if (measures.length === 0 && uom) return uom;

    if (measures.length === 0) return '';

    let result = measures.join(' × ');

    if (uom) {
      result += (result.endsWith(' ') ? '' : '') + uom;
    }

    return result;
  }


  const handleUOMClear = () => {
    setUOMSelected(null)
    setPreselectUOMDrop(null)
  }
  return (
    <>
      <section
        className="shelve-grey-bg"
        style={{
          background: viewMode == "edit" ? "var(--white-100)" : viewMode == "bins" ? "transparent" : viewMode == "form" ? "var(--white-100)" : "",
          border: viewMode == "edit" ? "1px solid #AFAFAF" : viewMode == "bins" ? "none" : viewMode == "form" ? "1px solid #AFAFAF" : "",
          zIndex: viewMode == "edit" ? 5 : 0,
        }}
      >
        {parentLenghts > 1 && (
          <HierarchyLines
            idx={-1}
            totalLength={1}
            depth={0}
            noChild={false}
            initialTop={62}
          // zIndex={0}
          ></HierarchyLines>
        )}

        <HierarchyLines
          idx={0}
          totalLength={1}
          depth={1}
          initialTop={62}
          zIndex={4}
        ></HierarchyLines>
        <section
          className="shelve-expandable-header"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleHeaderClick()
            }
          }}
          onClick={handleHeaderClick}
          style={{
            backgroundColor: viewMode == 'form' ? 'transparent' : viewMode === 'bins' ? '#EFFCFF' : viewMode === 'edit' ? 'transparent' : '',
            border: viewMode == 'form' ? 'none' : viewMode === 'bins' ? '1px solid #B9D8DF' : viewMode === 'edit' ? 'none' : viewMode == "closed" ? "1px solid #E6E6E6" : 'none',
          }}
        >
          {(newShelf || draft || childrenDraft) && (
            <span className="draft-shelf-span">{LABELS.DRAFT}</span>
          )}
          <span></span>
          <h4>Shelf</h4>
          <p style={{
            // maxWidth: "15.3%",
            width: "22.5%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            minWidth: "5rem",
          }}>
            Name <Tooltip title={nameValue?.toUpperCase() || ""} arrow>
              <span className="ellipsis">{nameValue || "--"}</span>
            </Tooltip>
          </p>
          <p style={{
            width: "17%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            minWidth: "5rem",
          }}>
            Measurements{" "}
            <Tooltip
              title={getMeasurementText(lengthValue, widthValue, depthValue, UOMSelected, typeMeasurementMap, shelfBasicInfo)}
              arrow
            >
              <span className="ellipsis">
                {getMeasurementText(lengthValue, widthValue, depthValue, UOMSelected, typeMeasurementMap, shelfBasicInfo) ? getMeasurementText(lengthValue, widthValue, depthValue, UOMSelected, typeMeasurementMap, shelfBasicInfo) : "--"}
              </span>
            </Tooltip>
          </p>
          <p>
            Total Bins  <Tooltip title={"View Bins"}><button className="bin-num-span" onClick={handleViewShelves}>{totalBins || 0}</button></Tooltip>
          </p>
          <div className="actions-section-sitesExp">
            {viewMode !== "edit" && <p>New Bin</p>}
            {viewMode !== "edit" && (
              <Tooltip title="add new bin" arrow>
                <button onClick={(e) => {
                  e.stopPropagation();
                  createNewBin();
                }}>
                  <i

                    className="icon-add-aircraft"
                    style={{
                      fontSize: "1rem",
                      color: "var(--grey-200)",
                    }}
                  />
                </button>
              </Tooltip>
            )}
            {
              viewMode !== "edit" && <Tooltip title="View Bins" arrow>
                <button onClick={handleViewShelves}>
                  <i className="icon-icon_view_childs" style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }} />
                </button>
              </Tooltip>
            }

            {viewMode !== 'edit' && (
              <Tooltip title="Edit Shelf" arrow>
                <button onClick={handleEditClick}>
                  <i className="icon-edit" style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }} />
                </button>
              </Tooltip>
            )}
            <Tooltip title="delete shelf" arrow>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  openDeleteShelfDialog()
                }}

              >
                <i
                  className="icon-delete-new"
                  style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }}
                />
              </button>
            </Tooltip>
            {viewMode == "edit" && (
              <MultioptionButton
                buttons={multiOptionsBtn}
                buttonCallbacks={buttonsCallback}
              />
            )}
          </div>
        </section>
        <section
          className={`shelve-expandable-content ${isExpanded ? "open" : ""}`}
        >
          {viewMode == "edit" ? (
            <section className="shelve-edit-form">
              <div className="shelve-inp-cont">
                <Input
                  label="Name"
                  value={nameValue}
                  onChange={(e) => {
                    setNameValue(e.target.value);
                    setHasNameError(false);
                  }}
                  name={"Name"}
                  error={hasNameError}
                  upperCase={true}
                  disableAutocomplete={true}
                />

              </div>
              <div className="shelve-measurements">
                <div className="shelves-measures-inp-cont">
                  <div className="uom-drop-cont">
                    {UOMDropdownConfig && (
                      <Dropdowns handleClear={handleUOMClear} preSelectValue={preselectUOMDrop} onOptionSelect={getUOMSelection} dropdownFilters={filtersToMeasurements} data={UOMDropdownConfig} />
                    )}
                  </div>
                  <Input
                    isNumeric={true}
                    label={"length"}
                    value={lengthValue}
                    onChange={(e) => {
                      setLengthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disableAutocomplete={true}

                  />
                  <i className="icon-cross"></i>
                  {/* <p>Width</p> */}
                  <Input
                    isNumeric={true}
                    label="Width"
                    value={widthValue}
                    onChange={(e) => {
                      setWidthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disableAutocomplete={true}

                  />
                  <i className="icon-cross"></i>
                  < Input
                    isNumeric={true}
                    label="Depth"
                    value={depthValue}
                    onChange={(e) => {
                      setDepthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}

                  />
                </div>
              </div>
            </section>
          ) : viewMode == "form" ? (
            <section className="shelve-edit-form">
              <div className="shelve-inp-cont">
                <Input
                  label="Name"
                  value={nameValue}
                  onChange={(e) => {
                    setNameValue(e.target.value);
                    setHasNameError(false);
                  }}
                  name={"Name"}
                  error={hasNameError}
                  upperCase={true}
                  disableAutocomplete={true}
                  disabled={true}
                />

              </div>
              <div className="shelve-measurements">
                <div className="shelves-measures-inp-cont">
                  {/* <p>Measurements</p> */}
                  <div className="uom-drop-cont">
                    {UOMDropdownConfig && (
                      <Dropdowns handleClear={handleUOMClear} disabled={true} preSelectValue={preselectUOMDrop} onOptionSelect={getUOMSelection} dropdownFilters={filtersToMeasurements} data={UOMDropdownConfig} />
                    )}
                  </div>
                  {/* <p>Length</p> */}
                  <Input
                    isNumeric={true}
                    label={"length"}
                    value={lengthValue}
                    onChange={(e) => {
                      setLengthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disableAutocomplete={true}
                    disabled={true}
                  />
                  <i className="icon-cross"></i>
                  {/* <p>Width</p> */}
                  <Input
                    isNumeric={true}
                    label="Width"
                    value={widthValue}
                    onChange={(e) => {
                      setWidthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disableAutocomplete={true}
                    disabled={true}

                  />
                  <i className="icon-cross"></i>
                  < Input
                    isNumeric={true}
                    label="Depth"
                    value={depthValue}
                    onChange={(e) => {
                      setDepthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disabled={true}

                  />
                </div>
              </div>
            </section>
          ) : viewMode == "bins" ? (
            allbins.map((bin, idx) => {
              return (
                <BinExpandable
                  idx={idx}
                  length={bins.length}
                  key={bin.id}
                  bigParentListLenght={parentLenghts}
                  parentListLength={fullTotalLenght}
                  isDraft={binsDraft.some((draft) => draft.id === bin.id)}
                  isNewBin={mostRecentBin === bin.id}
                  informationOfDraft={binsDraft.find((draft) => draft.id === bin.id)}
                  shelfId={shelfBasicInfo.id}
                  rackId={rack_id}
                  siteId={siteId}
                  locationId={locationId}
                  binBasicInfo={bin}
                  reload={getAllBins}
                />
              );
            })
          ) : ""}
        </section>
      </section>
    </>
  );
};
